var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"gap-9x"}),_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"gap-3x"}),_c('div',{staticClass:"line-break-gray"}),_c('div',{staticClass:"gap-3x"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }